import React, { useEffect, useState } from 'react';
import styles from '../../formStyles.module.css';
import FormItem from '@/components/common/FormItem';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import Api from '@/api';

export default function TicketFormInfo({ info, setInfo, modalKey }) {
  const { showError } = useLayoutContext();
  const tCommon = useTranslations('common');
  const [colorList, setColorList] = useState([]);

  const getColors = () => {
    Api.colorList()
      .then((res) => {
        if (res?.data?.response) {
          setColorList(
            res?.data?.response?.map((d) => ({
              ...d,
              title: d?.display,
            })),
          );
        }
      })
      .catch((err) => {
        showError(err);
      });
  };
  useEffect(() => {
    getColors();
  }, []);

  let formarray = [
    {
      id: 2,
      type: 'checkbox',
      title: null,
      error: info?.messages?.type,
      value: info?.vehicleList,
      showError: info?.error?.type,
      key: 'type',
      vertical: false,
      multi: false,
      extraWrapperClass: `${styles.fullInput} w-full rtl`,
    },
    {
      id: 1,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('name'),
      title: tCommon('name'),
      error: info?.messages?.name,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.name,
      value: info?.name,
      key: 'name',
      disabled: true,

      // wrapper: `darkInput`,
    },
    {
      id: 2,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('family'),
      title: tCommon('family'),
      error: info?.messages?.family,
      value: info?.family,
      showError: info?.error?.family,
      error: info?.messages?.family,
      key: 'family',
      disabled: true,
      // wrapper: `darkInput`,
    },
    {
      type: 'myselectSort',
      id: 'brand',
      // extraInfo: '*',
      // styleColor: 'starColor',
      // classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'brand',
      value: info?.country || null,
      error: info?.messages?.brand,
      showError: info?.error?.brand,
      apiCategory: [
        {
          id: 1,
          searchkey: 'brand',
          listTitleKey: ['brand'],
          apiParams: { start: 0, limit: 10 },
          apiCall: Api.brandList,
          placeholder: 'برند',
          title: 'برند',
        },
      ],
    },
    {
      type: 'myselectSort',
      id: 'model',
      // extraInfo: '*',
      // styleColor: 'starColor',
      // classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'model',
      value: info?.model || null,
      error: info?.messages?.model,
      showError: info?.error?.model,
      apiCategory: [
        {
          id: 1,
          searchkey: 'title',
          listTitleKey: ['title'],
          apiParams: { start: 0, limit: 10, brand_id: info?.brand?.id },
          apiCall: Api.modelList,
          placeholder: 'مدل',
          title: 'مدل',
        },
      ],
    },
    {
      id: 11,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: 'کارکرد',
      title: 'کارکرد',
      error: info?.messages?.mileage,
      value: info?.mileage,
      showError: info?.error?.mileage,
      error: info?.messages?.mileage,
      key: 'mileage',
      // wrapper: `darkInput`,
    },

    {
      id: 9,
      type: 'select',
      list: colorList,
      // list: [{id:1, title:"red"}],
      value: info?.colorId || '',
      placeholder: 'رنگ',
      title: 'رنگ',
      extraInfo: ' * ',
      starColor: `starColor`,
      wrapperClassName: ` ${styles.wfull} ${styles.itemMargin} `,
      showError: info?.error?.colorId,
      error: info?.messages?.colorId,
      key: 'colorId',
      classChildern: `${styles.btn_select}`,
    },
    {
      id: 12,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: 'شماره VIN',
      title: 'شماره VIN',
      error: info?.messages?.vin,
      value: info?.vin,
      showError: info?.error?.vin,
      error: info?.messages?.vin,
      key: 'vin',
      // wrapper: `darkInput`,
    },
    {
      type: 'myselectSort',
      id: 'province',
      // extraInfo: '*',
      // styleColor: 'starColor',
      // classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'province',
      value: info?.province || null,
      error: info?.messages?.province,
      showError: info?.error?.province,
      // disabled: !info?.country?.id,
      apiCategory: [
        {
          id: 1,
          searchkey: 'title',
          listTitleKey: ['title'],
          apiParams: {
            start: 0,
            limit: 10,
            //  countryId: info?.country?.id
          },
          apiCall: Api.provinceList,
          placeholder: 'استان',
          title: 'استان',
        },
      ],
    },
    {
      type: 'myselectSort',
      id: 'city',
      // extraInfo: '*',
      // styleColor: 'starColor',
      classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'city',
      value: info?.city || null,
      disabled: !info?.province?.id,
      error: info?.messages?.city,
      showError: info?.error?.city,
      apiCategory: [
        {
          id: 1,
          searchkey: 'title',
          listTitleKey: ['title'],
          apiParams: { start: 0, limit: 10, province_id: info?.province?.id },
          apiCall: Api.cityList,
          placeholder: 'شهر',
          title: 'شهر',
        },
      ],
    },
    {
      id: 4,
      type: 'input',
      // extraInfo: '*',
      // styleColor: 'starColor',
      placeholder: 'شماره موتور',
      title: 'شماره موتور',
      error: info?.messages?.EngineNumber,
      value: info?.EngineNumber,
      showError: info?.error?.EngineNumber,
      error: info?.messages?.EngineNumber,
      key: 'EngineNumber',
      // wrapper: `darkInput`,
    },
    {
      id: 5,
      type: 'input',
      // extraInfo: '*',
      // styleColor: 'starColor',
      placeholder: 'شماره شاسی',
      title: 'شماره شاسی',
      error: info?.messages?.chassisNumber,
      value: info?.chassisNumber,
      showError: info?.error?.chassisNumber,
      error: info?.messages?.chassisNumber,
      key: 'chassisNumber',
      // wrapper: `darkInput`,
    },
  ];

  const [formList, setFormList] = useState(formarray);

  useEffect(() => {
    if (info) {
      setFormList(formarray);
    }
  }, [info, colorList]);

  const onChange = (value, key) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };
    if (key == 'brand') {
      valueIs.model = null;
    }
    if (key == 'country') {
      valueIs.province = null;
      valueIs.city = null;
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }
    if (key == 'province') {
      valueIs.city = null;
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }
    if (key == 'city') {
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }

    setInfo(valueIs);
  };

  console.log('info==', info);

  return (
    <div className={`${styles.formContainer}`}>
      {formList?.map((item, index) => (
        <FormItem
          type={item.type}
          inputType={item.inputType}
          key={index}
          item={item}
          index={index}
          onChange={onChange}
          value={info?.[`${item?.key}`]}
        ></FormItem>
      ))}
    </div>
  );
}
